import React, { useState } from "react";
import { ReactComponent as CloseSVG } from "App/common/icons-v2/close.svg";
import { useAuth } from "App/components/Auth";
import { highnote } from "@highnote/server/src/sdk";
import "./styles.scss";

export const WelcomeBanner = () => {
  const { user } = useAuth();
  const [dismissed, setDismissed] = useState(
    () => user?.homeBannerDismissed === true,
  );

  if (dismissed) return null;

  // Anon users cannot dismiss the banner.
  const canDismiss = !!user;

  const handleDismiss = () => {
    setDismissed(true);
    highnote.updateUser({
      id: user.id,
      data: { homeBannerDismissed: true },
    });
  };

  return (
    <div className="discover-welcome-banner">
      <div className="discover-welcome-banner-text">
        <h2 className="discover-welcome-banner-title">Welcome to Highnote</h2>
        <p className="discover-welcome-banner-body">
          Highnote is where artists, fans, and curators talk music. Join a Space
          or create your own, public or private.
        </p>
      </div>
      {canDismiss && (
        <button
          className="discover-welcome-banner-close"
          onClick={handleDismiss}
          aria-label="Dismiss"
        >
          <CloseSVG />
        </button>
      )}
    </div>
  );
};
